const formatDateToKorean = (date) => {
  if (!date) return '';
  const year = date.getFullYear() + '년';
  const month = (date.getMonth() + 1) + '월';
  const day = date.getDate() + '일에';
  return `${year} ${month} ${day}`;
};
export default formatDateToKorean;